module.exports = __webpack_public_path__ + "img/stade-renei-fc.5a33acf2.png";